import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Generated class for the DoubletapDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[doubleClick]' // Attribute selector
})
export class DoubleClickDirective {
  @Output() public doubleClick: EventEmitter<Event> = new EventEmitter();
  private static DOUBLE_CLICK_THRESHOLD: number = 500;
  private lastClick: number = 0;

  constructor() {}

  @HostListener('click', ['$event'])
  clickEvent(event:any) {
    event.preventDefault();
    event.stopPropagation();
    this.handleDoubleClick();    
  }

  handleDoubleClick() {
    const now = Date.now();
    if (Math.abs(now - this.lastClick) <= DoubleClickDirective.DOUBLE_CLICK_THRESHOLD) {
      this.doubleClick.emit();
      this.lastClick = 0;
    } else {
      this.lastClick = now;
    }
  }
}
